import { render, staticRenderFns } from "./athleteDetail.vue?vue&type=template&id=56d4164c&scoped=true"
import script from "./athleteDetail.vue?vue&type=script&lang=js"
export * from "./athleteDetail.vue?vue&type=script&lang=js"
import style0 from "./athleteDetail.vue?vue&type=style&index=0&id=56d4164c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4164c",
  null
  
)

export default component.exports